import React from "react";
import ComicVideoBase from "../../ComicVideoBase";

export default function ComicVideo46() {
  return (
    <ComicVideoBase
      titulo="La Viuda De Mi Vecina Capítulo 38– Rose Blue 3D"
      portada="https://melapelocondibujos.com/wp-content/uploads/2025/06/portada.jpg"
      video="https://www.xvideos.com/embedframe/ohlvcovcfd4"


      sugeridos={[]}
      info={{
        grupo: "Videos",
        tipo: "Animación",
        idioma: "Español",
        serie: "Street Fighter",
        personajes: ["Chun li"],
        etiquetas: ["Video", "3D"],
        artistas: "Hackerysmael",
      }}
    />
  );
}

export const infoManga = {
  titulo: "La Viuda De Mi Vecina Capítulo 38– Rose Blue 3D",
  portada:
    "https://melapelocondibujos.com/wp-content/uploads/2025/06/portada.jpg",
  enlace: "/comic/comicvideo46",
 fecha: "2025-05-16",
  info: {
    grupo: "Videos",
    tipo: "Animación",
    idioma: "Español",
    serie: "Street Fighter",
    personajes: ["Chun li"],
    etiquetas: ["Video", "3D"],
    artistas: "Hackerysmael",
  },
};